// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "app/chunks/" + chunkId + "." + {"126":"65d3292f","779":"1258c787","885":"44c97997"}[chunkId] + ".js";
};